export const formataData = (dataProgramada: string) => {
  const data = dataProgramada.split(" ")[0];
  const [mes, dia, ano] = data.split("/");
  return `${dia}/${mes}/${ano}`;
}
